import React, { useState } from 'react';

import { getGrowBundle } from "../../../../common/utils/config";
import Button from "../../../../common/components/Button";
import request from "../../../../common/utils/request";
import Processing from "../UI/Processing";
import Error from "../UI/Error";
import Info from "../UI/Info";
import SvgIcon from "../../../../common/SvgIcon";

export default function SubscriptionForm({ grow_bundle, stripe }) {
  const [grow, setGrow] = useState(grow_bundle);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const isActive = () => {
    return (grow == 'paid' || grow == 'pending');
  };

  const change_completed = () => {
    setLoading(false);
    setInfo('Change completed');
  };

  const handleError = (response) => {
    setError('Something went wrong. Please, reload page.');
    setLoading(false);
  };

  const handleSuccess = (response) => {
    switch (response.status) {
      case 'requires_action':
        stripe.confirmCardPayment(response.client_secret).then((result) => {
          if (result.error) {
            setError(result.error.message);
            setLoading(false);
          } else {
            setGrow('paid');
            change_completed();
          }
        });
        break;
      case 'fail':
        setError(response.error);
        setLoading(false);
        break;
      default: // 'succeeded'
        setGrow('paid');
        change_completed();
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setInfo('');

    request('post', '/api/subscriptions/buy_grow_bundle')
      .then(handleSuccess)
      .catch(handleError);
  };

  const growBundleInfo = getGrowBundle();


  return (
    <div className="form">
      <span>
        <div className="form-group row">
          <div className="col-xs-12">
            {!isActive() &&
            <div className="bundle-msg -with-border">
              <div className="bundle-msg_inset">
                <div className="bundle-msg_title-wrap -with-border">
                  <h1 className="bundle-msg_title">Support Bundle</h1>
                  <React.Fragment>
                    <strong className="bundle-msg_price">
                      {growBundleInfo.price_text}
                    </strong>
                    <span className="bundle-msg_price-label">one off payment</span>
                  </React.Fragment>
                </div>
                <div className="bundle-msg_text-wrap -text-center">
                  <p>Our ‘Support Bundle’ gives you additional advice and top tips to get you off to the best possible
                    start.
                  </p>
                  <p>Receive advice on pricing your services, how to acquire clients,
                    and gain full access to our templates to create beautiful 2D visuals.</p>
                </div>
              </div>
            </div>
            }
            {isActive() &&
            <div className="bundle-block -with-border">
              <div className="bundle-msg-block_inset">
                <div className="bundle-msg-block_title-wrap">

                  <h1 className="bundle-msg-block_title">You’ve purchased the support bundle.</h1>
                  <h1 className="bundle-msg-block_title">Great decision!</h1>
                  <h1 className="bundle-msg-block_title">Please visit the Academy to access</h1>
                  <h1 className="bundle-msg-block_title">the resources and training materials.</h1>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
        {!isActive() &&
        <div className="form-group row -submit-row" align="center">
          <Button
            type="submit"
            className="-primary"
            disabled={loading || isActive()}
            onClick={handleSubmit}
          >
            Add Support Bundle
          </Button>
        </div>
        }
      </span>


      {loading &&
      <Processing/>
      }

      {error &&
      <Error error={error}/>
      }

      {info &&
      <Info info={info}/>
      }
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/subscription_plan/components/GrowBundle/Form.js